/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Type de document :\n- IMAGE : Image JPG, PNG...\n- DOCUMENT : Document PDF, DOC...\n
 */
export const documentTypeSchema = z.enum(["IMAGE", "DOCUMENT"]).default("IMAGE").describe("Type de document :\n- IMAGE : Image JPG, PNG...\n- DOCUMENT : Document PDF, DOC...\n")